import Cookies from "js-cookie";
import {
  LOGIN_TIME_COOKIE,
  MILLISECONDS_PER_SECOND
} from "rivals/shared/constants";

const DEFAULT_STRICT_SIGN_IN_SECONDS = 7200;

function strictSignInSeconds(): number {
  if (process.env.NEXT_PUBLIC_STRICT_SIGN_IN_SECONDS !== undefined) {
    return parseInt(process.env.NEXT_PUBLIC_STRICT_SIGN_IN_SECONDS);
  }

  return DEFAULT_STRICT_SIGN_IN_SECONDS;
}

export function checkLoginTimestampCookie(): boolean {
  const timestamp = Cookies.get(LOGIN_TIME_COOKIE);
  if (!timestamp) {
    return false;
  }
  const loginTimeInMilliSeconds = +timestamp * MILLISECONDS_PER_SECOND;
  return !(
    loginTimeInMilliSeconds <
    Date.now() - strictSignInSeconds() * MILLISECONDS_PER_SECOND
  );
}
